import { useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import StackedAppStoreBadge from '@alltrails/layout/components/StackedAppStoreBadge';
import StackedGooglePlayBadge from '@alltrails/layout/components/StackedGooglePlayBadge';
import QRCodeStackedSvg from './qr-code-stacked.svg';
import styles from './QRCodeDownload.module.scss';

const QRCodeDownload = () => {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();
  return (
    <div className={styles.downloadCodeContainer}>
      <Image
        src={QRCodeStackedSvg}
        alt={intl.formatMessage({
          defaultMessage:
            'This QR code is intended to scan from a smartphone. If you have the AllTrails app, the link will open the app for you. If you don’t have the app, the link will take you to your device’s app store.'
        })}
      />
      <div className={styles.storeBadgeContainer}>
        <StackedAppStoreBadge intl={intl} languageRegionCode={languageRegionCode} height={50} />
        <StackedGooglePlayBadge intl={intl} languageRegionCode={languageRegionCode} height={50} />
      </div>
    </div>
  );
};

export default QRCodeDownload;
